export const diferenciais = [
  {
    titulo: "Organização de Código",
    descricao: "Código limpo, bem estruturado e com nomenclatura consistente. Cada arquivo tem uma responsabilidade clara.",
    icone: "📁",
  },
  {
    titulo: "Pensamento Arquitetural",
    descricao: "Capacidade de pensar na estrutura do projeto antes de escrever código. Planejamento de camadas, módulos e integrações.",
    icone: "🏗️",
  },
  {
    titulo: "Domínio em Backend",
    descricao: "Facilidade natural em construir APIs, gerenciar banco de dados e implementar regras de negócio complexas.",
    icone: "⚙️",
  },
  {
    titulo: "Domínio em Frontend",
    descricao: "Experiência no desenvolvimento de interfaces modernas com React, criação de componentes reutilizáveis, gerenciamento de estado, integração com APIs e foco em performance e usabilidade.",
    icone: "💻",
  },
  {
    titulo: "Evolução Constante",
    descricao: "Busca contínua por novos conhecimentos, padrões de projeto e melhores práticas do mercado.",
    icone: "📈",
  },
  {
    titulo: "Projetos de Grande Escala",
    descricao: "Capacidade de estruturar e organizar projetos grandes com clareza, mantendo a manutenibilidade a longo prazo.",
    icone: "🎯",
  },
];